<template>
    <DCard
        padding
    >
        <DTable
            :items="originalBrands"
            :fields="[
                {key: 'name', label: __('settings.lov_original_brands.table.original_brand')},
                {key: 'status', label: __('settings.lov_original_brands.table.status')},
                {key: 'actions', label: '', sorter: false, filter: false}
            ]"
            hover
            sorter
        >
            <template #status="{item}">
                <td>
                    <DBadge :color="item.status ? 'success' : 'danger'">
                        {{ item.status ? __('settings.lov_original_brands.table.active') : __('settings.lov_original_brands.table.inactive') }}
                    </DBadge>
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            :id="`edit_${item.id}`"
                            icon="pencil"
                            mini
                            @click="router.get(editOriginalBrandLink(item.id))"
                        />
                        <DButton
                            :id="`btn-delete-${item.id}`"
                            icon="trash-can-outline"
                            color="danger"
                            mini
                            :disabled="isInLoadingState"
                            @click="handeDeleteClick(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.lov_original_brands.add_button')"
                @click="handleCreate"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('settings.lov_original_brands.delete_confirm_modal.title')"
            :message="__('settings.lov_original_brands.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteOriginalBrand"
        />
    </DCard>
</template>

<script>
import App from '~@/App.vue'
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import LovLayout from '~@/Pages/Settings/Lov/LovLayout.vue'
import { __ } from '~@/Composables/translation'

export default {
    layout: [App, LovLayout]
}
</script>

<script setup>
defineProps({
    originalBrands: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const showConfirmationModal = ref(false)
const selectedItem = ref(null)

function editOriginalBrandLink (id) {
    return route('settings.original-brands.edit', { originalBrand: id })
}
function handeDeleteClick (id) {
    selectedItem.value = id
    showConfirmationModal.value = true
}

function deleteOriginalBrand () {
    router.delete(route('settings.original-brands.destroy', selectedItem.value))
    showConfirmationModal.value = false
}
function handleCreate () {
    router.get(route('settings.original-brands.create'))
}
</script>
